import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  header: {
    color: '#555555'
  },
  list: {
    width: '275px'
  },
  icon: {
    height: '25px'
  },
  logo: {
    margin: '0 auto'
  }
});
